import React, { useState, useContext } from 'react'
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Link } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import mRegister from '../../../Controller/auth'
import DialogInfo from '../../../Dialog/DialogInfo'
import { TextField } from '@material-ui/core';
import validate from 'validate.js';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/moment';
import moment from 'moment-timezone'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AuthContext from '../../../context/auth-context';
import ForgetPassword from '../../../Dialog/ForgetPassword';


const MadeWithLove = () => {
    if (process.env.REACT_APP_COMPANY === "ipos") {
        // eslint-disable-next-line 
        return (
            <Typography variant="body2" align="center">
                Developed by <a color="inherit" className="colorLogin" target="_blank" href="ipos.co.id">iPOS</a> team
            </Typography>
        );
    } else return null

}
const myFormat = /^(\+62|\+0|0|62)8(1[123]|52|51|53|21|22|23)[0-9]{5,9}$|^(\+62815|0815|62815|\+0815|\+62816|0816|62816|\+0816|\+62858|0858|62858|\+0814|\+62814|0814|62814|\+0814)[0-9]{5,9}$|^(\+62855|0855|62855|\+0855|\+62856|0856|62856|\+0856|\+62857|0857|62857|\+0857)[0-9]{5,9}$|^(\+62817|0817|62817|\+0817|\+62818|0818|62818|\+0818|\+62819|0819|62819|\+0819|\+62859|0859|62859|\+0859|\+0878|\+62878|0627|0629|06410642|0643|0644|0645|0646|0650|0651|0652|0653|0654|0655|0656|0657|0658|0659|061|0620|0621|0622|0623|0624|0625|0626|0627|0628|0630|0631|0632|0633|0634|0635|0636|0639|0751|0752|0753|0754|0755|0756|0757|0759|0760|0761|0762|0763|0764|0765|0766|0767|0768|0769|0624|0770|0771|0772|0773|0776|0777|0778|0779|0740|0741|0742|0743|0744|0745|0746|0747|0748|0702|0711|0712|0713|0714|0730|0731|0733|0734|0735|0715|0716|0717|0718|0719|0732|0736|0737|0738|0739|0721|0722|0723|0724|0725|0726|0727|0728|0729|021|0252|0253|0254|0257|022|0231|0232|0233|0234|0251|0260|0261|0262|0263|0264|0265|0266|0267|0274|024|0271|0272|0273|0274|0275|0276|0280|0281|0282|0283|0284|0285|0286|0287|0289|0291|0292|0293|0294|295|0296|0297|0298|0299|0356|031|0321|0322|0323|0324|0325|0327|0328|0331|0332|0333|0334|0335|0336|0338|0341|0342|0343|0351|0352|0353|0354|0355|0356|0357|0358|0361|0362|0363|0365|0366|0368| 0364|0370|0371|0372|0373|0374|0376|0380|0381|0382|0383|0384|0385|0386|0387|0388|0389|0561|0562|0563|0564|0565|0567|0568|0534|0513|0522|0525|0526|0528|0531|0532|0536|0537|0538|0539|0511|0512|0517|0518|0526|0527|0541|0542|0543|0545|0548|0549|0554|0551|0552|0553|0556|0430|0431|0432|0434|0438|0435|0443|0445|0450|0451|0452|0453|0454|0457|0458|0461|0462|0463|0464|0465|0455|0422|0426|0428|0410|0411|0413|0414|0417|0418|0419|0420|0421|0423|0427|0471|0472|0473|0474|0475|0481|0482|0484|0485|0401|0402|0403|0404|0405|0408|0910|0911|0913|0914|0915|0916|0917|0918|0921|0922|0923|0924|0927|0929|0931|0901|0902|0951|0952|0955|0956|0957|0966|0967|0969|0971|0975|0980|0981|0983|0984|0985|0986|0878|62878|\+0877|\+62877|0877|62877)[0-9]{5,9}$|^(\+62|\+0|0|62)8(28)[0-9]{5,9}$|^(\+62|\+0|0|62)8(3[128])[0-9]{5,9}$|^(\+62|\+0|0|62)8(8[1278])[0-9]{5,9}$|^(\+62|\+0|0|62)8(9[678])[0-9]{5,9}$/g;

const Register = (props) => {
    const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    const [dialogtext, setDialogtext] = useState<string>("")
    const [isForget, setIsForget] = useState<boolean>(false)
    const [form, setForm] = useState<any>({
        email: '',
        nohp: '',
        namaLengkap: '',
        alamat: '',
        password: '',
        password2: '',
        dof: moment(),
        gender: ''
    })
    const { login } = useContext(AuthContext);

    const handleForget = () => {
        setIsForget(true)
    }
    const handleForgetInfo = (info) => {
        setIsForget(false)
        setOpenConfirmInfo(true)
        setDialogtext(info)
    }
    const validateForm = () => {
        const promNamaOutlet = new Promise((resolve, reject) => {
            const constraint = {
                email: {
                    email: {
                        message: "Email tidak valid"
                    }
                },
                nohp: {
                    length: {
                        minimum: 8,
                        message: "Nomor Handphone terlalu pendek"
                    },
                    format: {
                        pattern: myFormat,
                        message: "Nomor Handphone tidak sesuai dengan format operator Indonesia."
                    }
                },
                namaLengkap: {
                    length: {
                        minimum: 3,
                        message: "Nama Lengkap minimal terdiri dari 3 huruf"
                    },
                },
                password: {
                    length: {
                        minimum: 8,
                        message: "Password minimal terdiri dari 8 huruf dan angka"
                    },
                },
                password2: {
                    length: {
                        minimum: 8,
                        message: "Password minimal terdiri dari 8 huruf dan angka"
                    },
                }, alamat: {
                    length: {
                        miminum: 10,
                        message: "Alamat terlalu pendek. Harap mengisi alamat lengkap"
                    }
                }
            }
            const validator = validate(form, constraint, { fullMessages: false });
            if (validator === undefined) {
                resolve(true);
            } else {
                reject(validator);
            }
        })
        return Promise.all([promNamaOutlet]);
    }
    const onRegister = (ev: any) => {
        validateForm().then(() => {
            let email: string = form.email
            let namaLengkap: string = form.namaLengkap
            let nohp: string = form.nohp
            let password: string = form.password
            let password2: string = form.password2
            let alamat: string = form.alamat
            let dof: string = form.dof
            let gender: string = form.gender
            if (password !== password2) {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>Password yang anda masukan harus sama<p/>`)
                return
            }
            let hpNew: string
            if (nohp.substring(0, 1) === "0") {
                hpNew = `62${nohp.substring(1)}`
            } else if (nohp.substring(0, 3) === "+62") {
                hpNew = nohp.substring(1)
            } else hpNew = nohp
            const _address = alamat.replace(/\n/g, "<BR>");
            mRegister.register(email, namaLengkap, hpNew, password, _address, moment(dof).format("YYYY-MM-DD"), gender).then((res: any) => {
                if (res.success) {
                    login(email, password);
                } else {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${res.info}<p/>`)
                }
            }).catch(err => {
                console.log(err);
                setOpenConfirmInfo(true)
                setDialogtext(`<p>${err[0].message}<p/>`)
            })
            ev.preventDefault();
        }).catch(err => {
            const keys = Object.keys(err);
            var errorMessage = "";
            for (const key of keys) {
                errorMessage += err[key] + "<br/>";
            }
            // console.log(err);
            setOpenConfirmInfo(true)
            setDialogtext(`<p>${errorMessage}<p/>`)
        })
    }

    const handleChange = (ev) => {
        var value = ev.target.value;
        const key = ev.target.id || ev.target.name;
        const newValue = { ...form };
        newValue[key] = value;
        setForm(newValue);
    }
    return (
        <Container component="main" maxWidth="xs" style={{ marginTop: '-70px' }}>
            <CssBaseline />
            <div className="paper">
                <Avatar className="avatar">
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">Sign Up</Typography>
                {/* <form className="form" onSubmit={onRegister}> */}
                <form className="form">
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="E-mail"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={form.email}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="nohp"
                        label="No Handphone"
                        name="nohp"
                        autoComplete="nohp"
                        type="tel"
                        value={form.nohp}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="namaLengkap"
                        label="Nama Lengkap"
                        name="namaLengkap"
                        autoComplete="namaLengkap"
                        value={form.namaLengkap}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="alamat"
                        label="Alamat"
                        name="alamat"
                        autoComplete="alamat"
                        value={form.alamat}
                        onChange={handleChange}
                        multiline={true}
                        rows={2}
                    />
                    <div className="formReg">
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <KeyboardDatePicker
                                fullWidth={true}
                                margin="normal"
                                label="Date Of Birth"
                                format="DD-MM-YYYY"
                                value={form.dof}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                onChange={(e) => setForm({ ...form, dof: e })}
                                //ampm={false}
                                disableFuture
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <FormLabel component="legend">Gender</FormLabel>
                    <RadioGroup
                        aria-label="gender"
                        name="gender"
                        onChange={handleChange}
                        value={form.gender}
                    >
                        <FormControlLabel value="F" control={<Radio />} label="Female" />
                        <FormControlLabel value="M" control={<Radio />} label="Male" />
                    </RadioGroup>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={form.password}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password2"
                        label="Ulangi Masukan Password"
                        type="password"
                        id="password2"
                        autoComplete="current-password2"
                        value={form.password2}
                        onChange={handleChange}
                    />
                    <Button
                        // type="submit"
                        fullWidth
                        variant="contained"
                        className="submit"
                        onClick={onRegister}
                    >Daftar</Button>
                    <Grid container>
                        <Grid item xs>
                            <Link to="#" onClick={handleForget} className="colorLogin" variant="body2">Lupa password?</Link>
                        </Grid>
                        <Grid item>
                            <Link to="login" className="colorLogin" variant="body2">
                                {"Sudah punya akun? masuk"}
                            </Link>
                        </Grid>
                    </Grid>

                </form>
            </div>

            <Box mt={5}>
                <MadeWithLove />
            </Box>
            {isForget && (
                <ForgetPassword open={isForget} setOpen={setIsForget} info={handleForgetInfo} />
            )}
            {OpenConfirmInfo && (
                <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} redirect={props.history.push} />
            )}
        </Container>
    );
}

export default Register;